import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { getEnv } from "./utils/getEnv";

if (getEnv() === "live") {
  datadogRum.init({
    applicationId: "2e18ec47-5b18-48d4-bcc6-594bb3d5515e",
    clientToken: "pub174ed652b5b095d61bc32157559208d9",
    site: "datadoghq.eu",
    service: "React E-commerce",
    env: "prod",
    version: "1.0.0",
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: false })],
    sessionReplaySampleRate: 100
  });

  datadogRum.startSessionReplayRecording();
}
